import { render, staticRenderFns } from "./colaboradoresHierarchy.vue?vue&type=template&id=49a92fb2"
import script from "./colaboradoresHierarchy.vue?vue&type=script&lang=js"
export * from "./colaboradoresHierarchy.vue?vue&type=script&lang=js"
import style0 from "./colaboradoresHierarchy.vue?vue&type=style&index=0&id=49a92fb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
